/* MTX — « Tomette au prénom » (modèle product.prenom uniquement).
   Module à part, hors moteur guidé : aucun fichier mtp-guided*, mtp-native-skin*,
   mtp-atelier-mobile*, mt-configurateur*, mt-editeur* n'est modifié.
   Parcours : 1 Prénom (champ du moteur + liste des 850 prénoms référencés)
              2 Sa phrase (4 phrases écrites pour ce prénom, ou passe-partout, ou « Écrire ma
                propre phrase ») — la liste reste ouverte pour essayer d'autres phrases sur la tomette
              3 Forme & options (étape du moteur).
   Le module écrit dans les champs du moteur (input.mtp-fin[data-fk="prenom|phrase1|phrase2|phrase3"])
   en déclenchant « input », comme mtp-gps et l'Atelier mobile : aperçu, panier et fichiers de
   gravure restent ceux du moteur. Les étapes « Phrase, ligne 1/2/3 » sont masquées. */
(function(){
  'use strict';
  if (window.__MTXP__) return; window.__MTXP__ = true;
  var SRC = 'https://admin.mytomette.fr/json/prenoms.json';
  var MOBILE = '(max-width: 759px)';
  var T = {}; try { T = JSON.parse(document.getElementById('mtxPrenomTxt').textContent); } catch(e) {}
  function t(k, d){ return (T && T[k]) || d || ''; }

  /* ── données ───────────────────────────────────────────────── */
  var data = null, attente = null;
  function norm(s){
    s = String(s || '');
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch(e) {}
    return s.toLowerCase().replace(/[^a-z' -]/g, '').replace(/\s+/g, ' ').trim();
  }
  function charger(){
    if (data) return Promise.resolve(data);
    if (attente) return attente;
    attente = fetch(SRC, { cache: 'force-cache' }).then(function(r){ return r.json(); }).then(function(j){
      data = {
        idx: (j.prenoms || []).map(function(p){ return { n: p.n, k: norm(p.n), p: p.p || [] }; }),
        nonref: j.nonref || []
      };
      return data;
    })['catch'](function(){ attente = null; return null; });
    return attente;
  }
  function trouver(q){
    var k = norm(q); if (!k || !data) return [];
    var debut = [], dedans = [];
    data.idx.forEach(function(p){ if (p.k.indexOf(k) === 0) debut.push(p); else if (k.length > 2 && p.k.indexOf(k) > 0) dedans.push(p); });
    debut.sort(function(a, b){ return (a.k === k ? -1 : 0) - (b.k === k ? -1 : 0) || a.k.length - b.k.length || a.k.localeCompare(b.k); });
    return debut.concat(dedans).slice(0, 8);
  }
  function exact(v){ var k = norm(v); if (!k || !data) return null; for (var i = 0; i < data.idx.length; i++) if (data.idx[i].k === k) return data.idx[i]; return null; }

  /* ── découpe d'une phrase en 1 à 3 lignes (le moteur ne coupe jamais seul) ── */
  var FAIBLES = /^(à|a|de|du|des|la|le|les|l'|l’|un|une|et|ou|en|au|aux|sa|son|ses|ma|mon|mes|ta|ton|tes|sur|par|pour|sans|avec|dans|qui|que|qu'|qu’|ne|n'|n’|d'|d’|se|ce|si|mais|plus|très|tout|toute)$/i;
  function cout(l){
    var lens = l.map(function(x){ return x.length; });
    var max = Math.max.apply(null, lens), moy = lens.reduce(function(a, b){ return a + b; }, 0) / lens.length;
    var c = max * 4 + (max > 23 ? (max - 23) * 15 : 0);
    lens.forEach(function(n){ c += (n - moy) * (n - moy) * 0.08; });
    for (var i = 0; i < l.length - 1; i++){
      var w = l[i].split(' '), der = w[w.length - 1];
      if (FAIBLES.test(der)) c += 50;
      if (/[,;:.!?…]$/.test(l[i])) c -= 12;
      if (l[i].length < 7) c += 10;
    }
    if (l[l.length - 1].length < 6) c += 14;
    return c;
  }
  function decouper(txt){
    txt = String(txt || '').replace(/\s+/g, ' ').trim();
    var MAX = 22, w = txt.split(' ');
    if (!txt) return [];
    if (txt.length <= MAX || w.length < 2) return [txt];
    function meilleur(n){
      if (w.length < n) return null;
      var best = null;
      (function rec(i, k, acc){
        if (k === 1){
          var c = acc.concat([w.slice(i).join(' ')]);
          var m = Math.max.apply(null, c.map(function(x){ return x.length; })), v = cout(c);
          if (!best || v < best.v) best = { m: m, v: v, l: c };
          return;
        }
        for (var j = i + 1; j <= w.length - (k - 1); j++) rec(j, k - 1, acc.concat([w.slice(i, j).join(' ')]));
      })(0, n, []);
      return best;
    }
    var b2 = meilleur(2);
    if (b2 && b2.m <= MAX) return b2.l;
    var b3 = meilleur(3);
    return (b3 || b2).l;
  }
  /* saisie libre : on respecte les retours à la ligne du client (3 lignes max), sinon découpe auto */
  function lignesLibres(v){
    var parts = String(v || '').replace(/\r/g, '').split('\n').map(function(s){ return s.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    if (parts.length >= 2) return parts.length > 3 ? [parts[0], parts[1], parts.slice(2).join(' ')] : parts;
    return parts.length ? decouper(parts[0]) : [];
  }

  /* ── utilitaires DOM ───────────────────────────────────────── */
  function champ(k){ return document.querySelector('#mtp input.mtp-fin[data-fk="' + k + '"]'); }
  function pousser(inp, v){
    if (!inp || inp.value === v) return;
    inp.value = v;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function el(tag, cls, txt){ var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  /* nom avec la partie tapée surlignée (insensible aux accents) */
  function surligne(nom, q){
    var k = norm(q), frag = document.createDocumentFragment();
    if (!k){ frag.appendChild(document.createTextNode(nom)); return frag; }
    var nn = '', map = [];
    for (var i = 0; i < nom.length; i++){ var c = norm(nom[i]); if (nom[i] === ' ') c = ' '; for (var j = 0; j < c.length; j++){ nn += c[j]; map.push(i); } }
    var pos = nn.indexOf(k);
    if (pos < 0){ frag.appendChild(document.createTextNode(nom)); return frag; }
    var a = map[pos], b = map[pos + k.length - 1] + 1;
    if (a > 0) frag.appendChild(document.createTextNode(nom.slice(0, a)));
    frag.appendChild(el('mark', null, nom.slice(a, b)));
    if (b < nom.length) frag.appendChild(document.createTextNode(nom.slice(b)));
    return frag;
  }

  /* ── état ─────────────────────────────────────────────────── */
  var S = { pr: null, p: [], etape: null, ac: null, trouves: [], actif: -1, nom: '', mode: '', choisie: '', vus: [], propre: '' };

  function lignesActuelles(){ return S.p.map(function(i){ return i ? (i.value || '').trim() : ''; }); }
  function ecrire(l){ pousser(S.p[0], l[0] || ''); pousser(S.p[1], l[1] || ''); pousser(S.p[2], l[2] || ''); }

  /* ── liste des prénoms ─────────────────────────────────────── */
  function fermerListe(){ S.ac.classList.remove('mtxp-on'); S.ac.innerHTML = ''; S.trouves = []; S.actif = -1; }
  function montrerListe(){
    var q = S.pr.value, ac = S.ac;
    ac.innerHTML = '';
    if (norm(q).length < 1){ fermerListe(); return; }
    var ex = exact(q);
    if (S.trouves.length){
      ac.appendChild(el('p', 'mtxp-ac-h', t('acH', 'Cliquez sur son prénom')));
      S.trouves.forEach(function(p, i){
        var b = el('button', 'mtxp-it' + (i === S.actif ? ' mtxp-on' : '') + (ex && p === ex ? ' mtxp-exact' : ''));
        b.type = 'button'; b.setAttribute('role', 'option'); b.tabIndex = -1;
        var s = el('span'); s.appendChild(surligne(p.n, q)); b.appendChild(s);
        b.appendChild(el('span', 'mtxp-nb', String(t('nb', '{n} phrases')).replace('{n}', p.p.length)));
        b.addEventListener('mousedown', function(e){ e.preventDefault(); choisirPrenom(p.n); });
        ac.appendChild(b);
      });
      if (ex) ac.appendChild(el('p', 'mtxp-ac-pied', t('acExact', 'Cliquez sur le prénom pour découvrir ses phrases.')));
    } else if (norm(q).length >= 2){
      ac.appendChild(el('p', 'mtxp-ac-h', t('acAucun', 'Prénom pas encore dans notre liste')));
      var b2 = el('button', 'mtxp-it mtxp-exact'); b2.type = 'button'; b2.tabIndex = -1;
      b2.appendChild(el('span', null, String(t('acContinuer', 'Continuer avec « {n} »')).replace('{n}', q.trim())));
      b2.appendChild(el('span', 'mtxp-nb', t('acIdees', 'idées de phrases')));
      b2.addEventListener('mousedown', function(e){ e.preventDefault(); choisirPrenom(q.trim()); });
      ac.appendChild(b2);
      ac.appendChild(el('p', 'mtxp-ac-pied', t('acAucunPied', 'Nous vous proposerons des phrases qui vont à tout le monde, ou écrivez la vôtre.')));
    } else { fermerListe(); return; }
    ac.classList.add('mtxp-on');
  }
  function choisirPrenom(nom){
    S.interne = true; pousser(S.pr, nom); S.interne = false;
    fermerListe();
    afficherPhrases(nom, true);
  }

  /* ── étape « 2 Sa phrase » ─────────────────────────────────── */
  function marquer(){
    Array.prototype.forEach.call(S.etape.querySelectorAll('.mtxp-carte'), function(c){
      c.setAttribute('aria-pressed', S.mode === 'carte' && c.dataset.ph === S.choisie ? 'true' : 'false');
    });
    var pb = S.etape.querySelector('.mtxp-propre'); if (pb) pb.classList.toggle('mtxp-actif', S.mode === 'propre');
  }
  function appliquerCarte(ph){
    S.mode = 'carte'; S.choisie = ph;
    ecrire(decouper(ph));
    alerte(false); marquer();
  }
  function appliquerPropre(){
    S.mode = 'propre';
    var ta = S.etape.querySelector('.mtxp-propre textarea');
    var l = lignesLibres(ta ? ta.value : '');
    if (l.length) ecrire(l);
    majCompteur(); alerte(false); marquer();
  }
  function majCompteur(){
    var ta = S.etape.querySelector('.mtxp-propre textarea'), out = S.etape.querySelector('.mtxp-compteur');
    if (!ta || !out) return;
    var l = lignesLibres(ta.value);
    out.textContent = l.length ? String(t('lignes', '{n} ligne(s) sur la tomette')).replace('{n}', l.length) : '';
  }
  function tirer(n){
    var pool = data.nonref.filter(function(x){ return S.vus.indexOf(x) < 0; });
    if (pool.length < n){ S.vus = []; pool = data.nonref.slice(); }
    var out = [];
    while (out.length < n && pool.length){ var i = Math.floor(Math.random() * pool.length); out.push(pool.splice(i, 1)[0]); }
    S.vus = S.vus.concat(out); return out;
  }
  function attenteEtape(){
    var e = S.etape; e.classList.add('mtxp-attente');
    var corps = e.querySelector('.mtxp-corps'); corps.innerHTML = '';
    corps.appendChild(el('p', 'mtxp-note', t('attente', 'Tapez un prénom ci-dessus : ses phrases s’afficheront ici.')));
  }
  function afficherPhrases(nom, auto){
    if (!data) return;
    var p = exact(nom), e = S.etape, corps = e.querySelector('.mtxp-corps');
    S.nom = nom; e.classList.remove('mtxp-attente');
    corps.innerHTML = '';
    var phrases, labels = T.labels || [];
    if (p){
      corps.appendChild(el('p', 'mtxp-note', String(t('connu', '')).replace('{n}', p.n)));
      phrases = p.p.slice();
    } else {
      corps.appendChild(el('p', 'mtxp-note', t('inconnu', '')));
      phrases = tirer(4); labels = [];
    }
    var cartes = el('div', 'mtxp-cartes');
    phrases.forEach(function(ph, i){
      var b = el('button', 'mtxp-carte'); b.type = 'button'; b.dataset.ph = ph;
      if (labels[i]) b.appendChild(el('b', null, labels[i]));
      b.appendChild(el('span', null, ph));
      b.addEventListener('click', function(){ appliquerCarte(ph); });
      cartes.appendChild(b);
    });
    corps.appendChild(cartes);
    if (!p){
      var plus = el('button', 'mtxp-plus', t('plus', '↻ Autres idées')); plus.type = 'button';
      plus.addEventListener('click', function(){ afficherPhrases(nom, false); });
      corps.appendChild(plus);
    }
    /* « Écrire ma propre phrase » : bloc à part, avec sa zone de saisie */
    var pb = el('div', 'mtxp-propre');
    var bt = el('button', 'mtxp-propre-bt'); bt.type = 'button';
    bt.appendChild(el('span', 'mtxp-propre-ic', '✎'));
    var tx = el('span', 'mtxp-propre-tx'); tx.appendChild(el('strong', null, t('propre', 'Écrire ma propre phrase'))); tx.appendChild(el('small', null, t('propreSous', '')));
    bt.appendChild(tx);
    var zone = el('div', 'mtxp-propre-zone');
    var ta = el('textarea'); ta.rows = 3; ta.maxLength = 90; ta.placeholder = t('propreEx', ''); ta.value = S.propre;
    ta.setAttribute('aria-label', t('propre', 'Écrire ma propre phrase'));
    var aide = el('p', 'mtxp-propre-aide'); aide.appendChild(el('span', null, t('propreAide', ''))); aide.appendChild(el('b', 'mtxp-compteur'));
    zone.appendChild(ta); zone.appendChild(aide);
    pb.appendChild(bt); pb.appendChild(zone);
    bt.addEventListener('click', function(){ appliquerPropre(); setTimeout(function(){ try { ta.focus(); } catch(e) {} }, 30); });
    ta.addEventListener('input', function(){ S.propre = ta.value; S.mode = 'propre'; var l = lignesLibres(ta.value); ecrire(l); majCompteur(); marquer(); });
    corps.appendChild(pb);
    corps.appendChild(el('p', 'mtxp-alerte', t('alerte', 'Choisissez une phrase ou écrivez la vôtre.')));

    /* une phrase est toujours posée pour que l'aperçu soit complet ; on ne remplace pas une saisie libre */
    if (S.mode === 'propre' && S.propre.trim()) appliquerPropre();
    else if (auto || !lignesActuelles().join('').trim()) appliquerCarte(phrases[0]);
    else marquer();
    if (auto && window.matchMedia && matchMedia(MOBILE).matches){
      var r = e.getBoundingClientRect();
      if (r.top > window.innerHeight * 0.75) e.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
  function alerte(on){ var a = S.etape && S.etape.querySelector('.mtxp-alerte'); if (a) a.classList.toggle('mtxp-on', !!on); }

  /* ── étapes du moteur : masquage des lignes, prénom toujours ouvert, numéros 1-2-3 ── */
  function entretien(){
    var stPr = S.pr.closest('.mtp-step');
    if (stPr) stPr.classList.add('mtxp-prenom');
    S.p.forEach(function(i){ var s = i && i.closest('.mtp-step'); if (s) s.classList.add('mtxp-masque'); });
    if (stPr && S.etape && S.etape.previousElementSibling !== stPr) stPr.parentNode.insertBefore(S.etape, stPr.nextSibling);
    var n = 1, enfants = stPr ? stPr.parentNode.children : [];
    Array.prototype.forEach.call(enfants, function(c){
      if (c.classList.contains('mtxp-masque')) return;
      if (c === S.etape){ var nm = c.querySelector('.mtxp-num'); if (nm) nm.textContent = String(n); n++; return; }
      if (c.classList.contains('mtp-step')){ var sn = c.querySelector('.mtp-stepnum'); if (sn && sn.textContent !== String(n)) sn.textContent = String(n); n++; }
    });
  }

  function demarrer(){
    var pr = champ('prenom'), p1 = champ('phrase1');
    if (!pr || !p1) return false;
    if (pr.dataset.mtxp === '1'){ entretien(); return true; }
    pr.dataset.mtxp = '1';
    S.pr = pr; S.p = [p1, champ('phrase2'), champ('phrase3')];

    var fwrap = pr.parentNode; fwrap.classList.add('mtxp-f');
    S.ac = el('div', 'mtxp-ac'); S.ac.setAttribute('role', 'listbox'); S.ac.id = 'mtxpAc';
    pr.setAttribute('aria-autocomplete', 'list'); pr.setAttribute('aria-controls', 'mtxpAc');
    fwrap.appendChild(S.ac);

    S.etape = el('div', 'mtxp-step mtxp-attente'); S.etape.id = 'mtxpPhrase'; S.etape.setAttribute('aria-live', 'polite');
    S.etape.appendChild(el('span', 'mtxp-num', '2'));
    S.etape.appendChild(el('span', 'mtxp-titre', t('titre', 'Sa phrase')));
    S.etape.appendChild(el('div', 'mtxp-corps'));
    entretien(); attenteEtape();

    var tSaisie = null;
    pr.addEventListener('focus', function(){ charger().then(function(){ if (document.activeElement === pr && norm(pr.value)) { S.trouves = trouver(pr.value); montrerListe(); } }); });
    pr.addEventListener('input', function(){
      if (S.interne) return; /* valeur posée par le module (clic sur un prénom) */
      var v = pr.value;
      charger().then(function(){
        if (pr.value !== v) return;
        if (document.activeElement === pr){ S.trouves = trouver(v); S.actif = -1; montrerListe(); }
        clearTimeout(tSaisie);
        if (!norm(v)) attenteEtape();
        /* prénom référencé tapé en entier : ses phrases s'affichent aussi, la liste reste là pour cliquer */
        else if (exact(v) && norm(v) !== norm(S.nom)) tSaisie = setTimeout(function(){ if (pr.value === v) afficherPhrases(exact(v).n, true); }, 350);
      });
    });
    pr.addEventListener('keydown', function(e){
      if (!S.ac.classList.contains('mtxp-on')) return;
      var nb = S.ac.querySelectorAll('.mtxp-it').length;
      if (e.key === 'ArrowDown'){ S.actif = Math.min(nb - 1, S.actif + 1); montrerListe(); e.preventDefault(); }
      else if (e.key === 'ArrowUp'){ S.actif = Math.max(0, S.actif - 1); montrerListe(); e.preventDefault(); }
      else if (e.key === 'Enter'){
        e.preventDefault(); e.stopPropagation();
        var cible = S.trouves[S.actif] || exact(pr.value) || S.trouves[0];
        choisirPrenom(cible ? cible.n : pr.value.trim());
      }
      else if (e.key === 'Escape'){ fermerListe(); }
    }, true);
    pr.addEventListener('blur', function(){
      setTimeout(function(){
        if (!S.ac.classList.contains('mtxp-on')) return;
        fermerListe();
        var v = pr.value.trim();
        if (norm(v).length >= 2 && norm(v) !== norm(S.nom)) afficherPhrases(exact(v) ? exact(v).n : v, true);
      }, 180);
    });
    document.addEventListener('mousedown', function(e){ if (S.ac && !fwrap.contains(e.target)) { if (S.ac.classList.contains('mtxp-on')) pr.blur(); } }, true);

    /* garde panier : pas d'ajout sans phrase (les champs du moteur sont masqués) */
    document.addEventListener('click', function(e){
      var b = e.target && e.target.closest && e.target.closest('button, a');
      if (!b || !/panier|cart/i.test(b.textContent || '') || !b.closest('#mtp, .product-information')) return;
      if (!(S.pr.value || '').trim()) return; /* le moteur gère le prénom manquant */
      if (!lignesActuelles().join('').trim()){
        e.preventDefault(); e.stopImmediatePropagation();
        alerte(true); S.etape.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, true);

    /* reprise (lien « modifier » #g=, retour arrière) : prénom et lignes déjà remplis */
    if (norm(pr.value)){
      charger().then(function(){
        var l = lignesActuelles(), joint = l.filter(Boolean).join(' ');
        var p = exact(pr.value), trouve = p && p.p.filter(function(ph){ return norm(ph) === norm(joint); })[0];
        if (trouve){ S.mode = 'carte'; S.choisie = trouve; }
        else if (joint){ S.mode = 'propre'; S.propre = l.filter(Boolean).join('\n'); }
        afficherPhrases(p ? p.n : pr.value.trim(), false);
      });
    }
    return true;
  }

  /* le moteur rend son formulaire en différé : on attend ses champs et on se rattache
     s'il le reconstruit */
  var essais = 0;
  (function boucle(){
    var ok = false; try { ok = demarrer(); } catch(e) {}
    essais++;
    if (ok || essais < 120) setTimeout(boucle, ok ? 1500 : 250);
  })();
  document.addEventListener('mtp:ready', function(){ setTimeout(function(){ try { demarrer(); } catch(e) {} }, 0); });
})();
